import React from 'react';

const TextBox = ({ text, options, onContinue, memory }) => {

    return (
        <div className='absolute z-40 bottom-0 left-0 w-full h-1/4 px-20 py-5 no-select'>
            <div
                className={`${!options && 'cursor-pointer'} flex relative flex-col p-1 md:p-2 lg:p-3 h-full bg-yellow-50 bg-opacity-60 border-4 border-gray-800`}
                onClick={() => !options && onContinue()}
            >
                <div className='flex flex-col w-min gap-3 h-28 md:h-32 lg:h-36 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-yellow-100 p-2'>
                    {text && <span key={text} className='text-sm md:text-base lg:text-xl font-bold typing-caret'>{text}</span>}
                    {options && (
                        <div key={text + 'options'} className='flex flex-col gap-2 after-typing'>
                            {options.map((option, index) => {
                                let isDisabled = false;
                                let displayText = option.text;

                                if (option.text === 'flower') {
                                    if (memory?.hasFlowers) {
                                        displayText = 'Aim flowers at Jaden';
                                    } else {
                                        displayText = 'Aim flowers at Jaden (Need flowers)';
                                        isDisabled = true;
                                    }
                                }

                                console.log('isDisabled', isDisabled);

                                return (
                                    <button
                                        key={option.text}
                                        className={`text-lg w-min group transition-all duration-300 ease-in-out ${isDisabled && 'opacity-50 cursor-not-allowed'}`}
                                        onClick={() => onContinue(option.value)}
                                        disabled={isDisabled}
                                    >
                                        <span className='group-hover:font-bold'>{`>`}</span> {displayText}
                                    </button>
                                );
                            })}
                        </div>
                    )}
                </div>
                {!options && (
                    <span key={text + 'continue'} className='text-xs md:text-sm lg:text-lg after-typing absolute bottom-5'>
                        Click to continue...
                    </span>
                )}
            </div>
        </div>
    );
};

export default TextBox;